import * as React from 'react';
const SvgList = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M6.814 7.548a.526.526 0 0 1-.541-.537q0-.229.155-.387a.52.52 0 0 1 .386-.159h9.228q.23 0 .386.155.156.154.155.383a.53.53 0 0 1-.155.387.52.52 0 0 1-.386.158zm0 2.994a.526.526 0 0 1-.541-.537q0-.23.155-.388a.52.52 0 0 1 .386-.158h9.228q.23 0 .386.154t.155.383a.53.53 0 0 1-.155.387.52.52 0 0 1-.386.159zm0 2.994a.527.527 0 0 1-.541-.538q0-.228.155-.387a.52.52 0 0 1 .386-.159h9.228q.23 0 .386.155.156.154.155.383a.53.53 0 0 1-.155.387.52.52 0 0 1-.386.159zm-2.807-5.94a.56.56 0 0 1-.407-.185.6.6 0 0 1-.183-.423.53.53 0 0 1 .183-.4.6.6 0 0 1 .417-.171q.233 0 .407.167.172.168.172.415a.6.6 0 0 1-.17.412.55.55 0 0 1-.42.186m0 2.986a.57.57 0 0 1-.407-.18.563.563 0 0 1 0-.829.6.6 0 0 1 .417-.17q.233 0 .407.167a.57.57 0 0 1 .172.43q0 .22-.17.401a.55.55 0 0 1-.42.181m0 3.002a.56.56 0 0 1-.407-.186.6.6 0 0 1-.183-.422.53.53 0 0 1 .183-.402.6.6 0 0 1 .417-.17q.233 0 .407.167.172.168.172.415a.6.6 0 0 1-.17.412.55.55 0 0 1-.42.186'
            />
        </g>
    </svg>
);
export default SvgList;
